import React from 'react';
import Chip from '@material-ui/core/Chip';

import { useStyles } from './styles';

/** @typedef {import('@material-ui/core').ChipProps} ChipProps */
/** @typedef {ChipProps & { color?: string, textColor?: string, classes?: Object, iconStyles?: Object }} FPChipProps */

/**
 * @param {FPChipProps} props
 */
const FPChip = ({ color, textColor, classes, iconStyles, label, ...rest }) => {
  const chipClasses = useStyles({ color, textColor, iconStyles })();

  if (!label) return null;

  return <Chip classes={{ ...chipClasses, ...classes }} label={label} {...rest} />;
};

FPChip.defaultProps = {
  textColor: 'white',
  variant: 'default',
  classes: {},
  iconStyles: null
};

export default FPChip;
